
function spinUp(input) {
    if (input) {
        let val = parseInt(input.value);
        let newValue = val;
        let max = 0;
        let step = 1;
        let isDisabled = false;

        if (input.getAttribute('max')) {
            max = parseInt(input.getAttribute('max'));
        }

        if (input.getAttribute('step')) {
            step = parseInt(input.getAttribute('step'));
        }

        if (input.disabled) {
            isDisabled = true;
        }

        if (input.readonly) {
            isDisabled = true;
        }

        if (!isDisabled) {
            var decimalPlacesStep = getDecimalPlaces(step);
            var toSet = parseFloat((val + step).toFixed(decimalPlacesStep));
            if (max != undefined && max > 0) {
                if (max >= toSet) {
                    newValue = toSet;
                }
            } else {
                newValue = toSet;
            }
        }

        input.value = newValue;
    }
}

function spinDown(input) {
    if (input) {
        let val = parseInt(input.value);
        let newValue = val;
        let min = 0;
        let step = 1;
        let isDisabled = false;

        if (input.getAttribute('min')) {
            min = parseInt(input.getAttribute('min'));
        }

        if (input.getAttribute('step')) {
            step = parseInt(input.getAttribute('step'));
        }

        if (input.disabled) {
            isDisabled = true;
        }

        if (input.readonly) {
            isDisabled = true;
        }

        if (!isDisabled) {
            var decimalPlacesStep = getDecimalPlaces(step);
            var toSet = parseFloat((val - step).toFixed(decimalPlacesStep));
            if (min != undefined && min > 0) {
                if (min <= toSet) {
                    newValue = toSet;
                }
            } else {
                newValue = toSet;
            }
        }

        input.value = newValue;
    }
}

function quantitySpinner(e, done) {
    let target = e.target;
    let quantity = target.closest('.js-quantity');
    if (quantity) {
        let input = target.closest('.js-quantity').querySelector('input[type="number"]');
        if (input) {
            if (target.closest('.js-spinnerUp')) {
                spinUp(input);
                done(input);
            }
            if (target.closest('.js-spinnerDown')) {
                spinDown(input);
                done(input);
            }
        }
    }
}

function getDecimalPlaces(number) {
    var str = Math.abs(number).toString();
    if (!str.includes('.')) {
        return 0;
    }
    return str.split('.')[1].length;
}

export function initQuantitySpinners(wrapper= document, done = function () {
}) {
    wrapper.removeEventListener('click', quantitySpinner);
    wrapper.addEventListener("click", (e) => quantitySpinner(e, done));
}